import { LOGO_MEDIUM_WHITE } from '@assets';
import { Close } from '@carbon/icons-react';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { Box, IconButton, makeStyles } from '@material-ui/core';
import { formatDate } from '@utils/formatter';
import React, { useState } from 'react';
import { TECH_INSIDE_BACKGROUND, TECH_INSIDE_MIDDLE_PNG } from '../Assets';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    top: 69,
    right: 24,
    zIndex: 9999,
    width: 343,
    height: 459,
    borderRadius: '12px',
    background: `url(${TECH_INSIDE_BACKGROUND}) no-repeat`,
    backgroundSize: '343px 459px',
    overflow: 'hidden',
    '& .top': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%',
      height: '80px',
      padding: '28px 28px 0 16px',
      '& .closeBtn': {
        width: '24px',
        height: '24px',
        padding: 0
      }
    },
    '& .middle': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: '16px',
      cursor: 'pointer',
      '& .eventTitle': {
        width: 310,
        height: 72,
        margin: '0 auto',
        textAlign: 'center'
      },
      '& .eventImage': {
        paddingTop: '4px',
        '& img': {
          height: 128
        }
      },
      '& .eventInfo': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        gap: '8px',
        '& .leftSide': {
          display: 'flex',
          flexDirection: 'column',
          alignContent: 'center',
          gap: '4px',
          '& .chip': {
            width: '46px',
            height: '22px',
            margin: '5px 0',
            textAlign: 'center',
            borderRadius: '11px',
            lineHeight: '21px',
            backgroundColor: '#182D54'
          }
        },
        '& .rightSide': {
          display: 'flex',
          flexDirection: 'column',
          alignContent: 'center',
          gap: '4px'
        }
      }
    },
    '& .bottom': {
      width: '100%',
      height: '53px',
      marginTop: '21px',
      backgroundColor: colorSet.gray1000,
      '& .closeDay': {
        height: '100%',
        padding: '16px'
      }
    },
    [theme.breakpoints.down(600)]: {
      top: 57,
      left: '50%',
      transform: 'translate(-50%,0)'
    },
    '& .clickToPage': {
      cursor: 'pointer'
    }
  }
}));

const MODAL_EXP = 'MODAL_EXP';

//11월 5일 이후 제거해야할 컴포넌트
const TechinsideModal: React.FC = () => {
  const classes = useStyles();
  const localStorage = window.localStorage;
  const modalExpireDate = localStorage.getItem(MODAL_EXP);
  const currentDate = formatDate(new Date().toISOString(), 'YYYY/MM/DD');
  const isClose = new Date().getTime() >= new Date('2022-11-05').getTime();
  const isShowInitState = modalExpireDate !== currentDate;

  const [isShow, setIsShow] = useState(isShowInitState);

  const handleClose = () => {
    setIsShow(false);
  };

  const handleCloseToday = () => {
    localStorage.setItem(MODAL_EXP, currentDate);
    setIsShow(false);
  };

  if (!isShow || isClose) return null;

  return (
    <Box className={classes.root}>
      <div className="top">
        <div className="capaLogo">
          <img src={LOGO_MEDIUM_WHITE} alt="LOGO_MEDIUM_WHITE" />
        </div>
        <IconButton
          onClick={handleClose}
          className="closeBtn"
          color="secondary"
        >
          <Close width={24} height={24} />
        </IconButton>
      </div>

      <div
        className="middle"
        onClick={() =>
          window.open(
            'https://blog.capa.ai/post/capa-2022-%EC%86%8C%EB%B6%80%EC%9E%A5%EB%BF%8C%EB%A6%AC%EA%B8%B0%EC%88%A0%EB%8C%80%EC%A0%84-%EC%B0%B8%EA%B0%80'
          )
        }
      >
        <div className="eventTitle">
          <CustomizedTypography variant="h5" fontWeight="700" color="secondary">
            2022 소부장 뿌리 기술대전에 <br /> CAPA가 참가합니다.
          </CustomizedTypography>
        </div>
        <div className="eventImage">
          <img src={TECH_INSIDE_MIDDLE_PNG} alt="TECH_INSIDE_MIDDLE_PNG" />
        </div>
        <div className="eventInfo">
          <div className="leftSide">
            <CustomizedTypography
              className="chip"
              variant="body1"
              fontWeight="700"
              color="secondary"
            >
              일시
            </CustomizedTypography>
            <CustomizedTypography
              className="chip"
              variant="body1"
              fontWeight="700"
              color="secondary"
            >
              위치
            </CustomizedTypography>
          </div>
          <div className="rightSide">
            <CustomizedTypography
              variant="h4"
              fontWeight="500"
              color="secondary"
            >
              2022.11.02(수) ~ 11.04(금)
            </CustomizedTypography>
            <CustomizedTypography
              variant="h4"
              fontWeight="500"
              color="secondary"
            >
              KINTEX 제 1 전시장 2홀 E20
            </CustomizedTypography>
          </div>
        </div>
      </div>

      <div className="bottom">
        <CustomizedButton
          onClick={handleCloseToday}
          className="closeDay"
          variant="text"
          color="secondary"
        >
          오늘하루 열지않기
        </CustomizedButton>
      </div>
    </Box>
  );
};

export default TechinsideModal;
